import { render, staticRenderFns } from "./Postos.vue?vue&type=template&id=18d704ab&"
import script from "./Postos.vue?vue&type=script&lang=js&"
export * from "./Postos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports